var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFitnessProgram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25048_20876",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#74788D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25048_20876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.58366 15L8.16699 7.41667L6.66699 8V10H5.00033V6.91667L9.20866 5.14583C9.4031 5.0625 9.60796 5.01042 9.82324 4.98958C10.0385 4.96875 10.2434 4.99306 10.4378 5.0625C10.6323 5.13194 10.8163 5.22917 10.9899 5.35417C11.1635 5.47917 11.3059 5.63889 11.417 5.83333L12.2503 7.16667C12.6392 7.79167 13.1496 8.28125 13.7816 8.63542C14.4135 8.98958 15.0975 9.16667 15.8337 9.16667V10.8333C14.8614 10.8333 13.9899 10.6389 13.2191 10.25C12.4482 9.86111 11.792 9.36111 11.2503 8.75L10.7503 10L12.5003 11.6667V15H10.8337V12.4583L9.20866 10.9583L8.33366 15H6.58366ZM11.2503 4.58333C10.792 4.58333 10.3996 4.42014 10.0732 4.09375C9.74685 3.76736 9.58366 3.375 9.58366 2.91667C9.58366 2.45833 9.74685 2.06597 10.0732 1.73958C10.3996 1.41319 10.792 1.25 11.2503 1.25C11.7087 1.25 12.101 1.41319 12.4274 1.73958C12.7538 2.06597 12.917 2.45833 12.917 2.91667C12.917 3.375 12.7538 3.76736 12.4274 4.09375C12.101 4.42014 11.7087 4.58333 11.2503 4.58333ZM10.0003 18.3333C8.84755 18.3333 7.76421 18.1146 6.75033 17.6771C5.73644 17.2396 4.85449 16.6458 4.10449 15.8958C3.35449 15.1458 2.76074 14.2639 2.32324 13.25C1.88574 12.2361 1.66699 11.1528 1.66699 10C1.66699 8.34722 2.09408 6.86111 2.94824 5.54167C3.80241 4.22222 4.91699 3.22222 6.29199 2.54167L7.04199 4.02083C5.94477 4.5625 5.05241 5.36458 4.36491 6.42708C3.67741 7.48958 3.33366 8.68056 3.33366 10C3.33366 11.8611 3.97949 13.4375 5.27116 14.7292C6.56283 16.0208 8.13921 16.6667 10.0003 16.6667C11.8614 16.6667 13.4378 16.0208 14.7295 14.7292C16.0212 13.4375 16.667 11.8611 16.667 10H18.3337C18.3337 11.1528 18.1149 12.2361 17.6774 13.25C17.2399 14.2639 16.6462 15.1458 15.8962 15.8958C15.1462 16.6458 14.2642 17.2396 13.2503 17.6771C12.2364 18.1146 11.1531 18.3333 10.0003 18.3333Z",
    fill: "#74788D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitnessProgram);
export default __webpack_public_path__ + "static/media/fitness-program.45967a68c0900049e60bca5783b834b5.svg";
export { ForwardRef as ReactComponent };